module.exports = __webpack_public_path__ + "img/photo-0019.3f4ed4ea.jpg";